
  import { Component, Prop, Vue } from "vue-property-decorator";
  import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
  import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";
  import UiButton from "@/components/button/ui-button.vue";
  import UILink from "@/components/common/UILink.vue";
  import ManagementRemoveDocumentPlaceholder
    from "@/components/skeletonPlaceholder/components/ManagementRemoveDocumentPlaceholder.vue";
  import DocumentAttachedTo from "@/entities/document/DocumentAttachedTo";
  import DocumentAttachedToDetails from "@/entities/document/DocumentAttachedToDetails";

  interface SingleEntity extends DocumentAttachedToDetails{
    title?: string
  }

  @Component({
    components: {
      ManagementRemoveDocumentPlaceholder,
      UILink,
      UiButton,
      ModalSectionsDivider,
      ModalFullScreen,
    },
  })
  export default class RemoveDocumentModal extends Vue {
    @Prop({ type: Array, required: true }) readonly attachedToEntities!: DocumentAttachedTo[];
    @Prop({ type: String, required: true }) readonly fileName!: string;
    @Prop({ type: Boolean, default: false }) readonly processing!: boolean;
    @Prop({ type: Boolean, default: false }) readonly attachedToEntitiesExist!: boolean;
    @Prop({ type: Boolean, default: false }) readonly attachedToInfoHidden!: boolean;

    get isAttachedToEntities(): boolean {
      if (this.attachedToInfoHidden) {
        return false;
      }

      return this.attachedToEntities.length > 0;
    }

    get singleEntity(): SingleEntity | undefined {
      const oneEntity = this.attachedToEntities.length === 1;
      const oneValue = this.attachedToEntities[0].details.length === 1;

      if (!oneEntity || !oneValue) {
        return;
      }

      const title = this.attachedToEntities[0].title || "";
      const { value, routeParams } = this.attachedToEntities[0].details[0];

      return {
        value,
        title,
        routeParams,
      }
    }

    get message(): string {
      return ``;
    }
  }
